import { isRecordEmpty } from 'hx-util';
import { useCallback, useState } from 'react';
export var useToggleMicrophone = function (_a) {
    var room = _a.room, initialState = _a.initialState;
    var _b = useState(initialState), isMicrophoneOn = _b[0], setIsMicrophoneOn = _b[1];
    var toggleMicrophone = useCallback(function () {
        if (isRecordEmpty(room))
            return;
        room.localParticipant.audioTracks.forEach(function (publication) {
            publication.track.enable(!isMicrophoneOn);
        });
        setIsMicrophoneOn(!isMicrophoneOn);
    }, [isMicrophoneOn, room]);
    return { isMicrophoneOn: isMicrophoneOn, toggleMicrophone: toggleMicrophone };
};
